import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-095fd374"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = {
  key: 0,
  class: "com_sec1"
}
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = { style: {"width":"80%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "バナー名", -1))
const _hoisted_13 = { colspan: "5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "リンクURL", -1))
const _hoisted_16 = { colspan: "5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "バナー画像", -1))
const _hoisted_19 = { class: "file-upload" }
const _hoisted_20 = ["accept"]
const _hoisted_21 = { colspan: "4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "キャプション", -1))
const _hoisted_24 = { colspan: "5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "表示期間", -1))
const _hoisted_27 = { colspan: "2" }
const _hoisted_28 = ["max"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "～", -1))
const _hoisted_30 = ["max"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = {
  class: "form-inline flex-container",
  style: {"width":"80%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isDataFetched)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h2", _hoisted_7, [
                    (_ctx.isUpdateMode)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("バナー編集")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("バナー登録")
                        ], 64))
                  ])
                ]),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("td", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          id: "txtBannerName",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bannerData.bannerName) = $event)),
                          type: "text",
                          placeholder: "バナー名",
                          maxlength: "255",
                          class: "form-control",
                          ref: "txtBannerName"
                        }, null, 512), [
                          [_vModelText, _ctx.bannerData.bannerName]
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("td", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          id: "kbannerUrlaisyaName",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bannerData.bannerUrl) = $event)),
                          type: "text",
                          placeholder: "リンクURL",
                          maxlength: "255",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.bannerData.bannerUrl]
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _hoisted_18,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.bannerData.bannerImgFileName)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-danger",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBannerImglClear()))
                              }, " クリア "))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-primary",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onContentsFileUpload()))
                              }, " 参照 ")),
                          _createElementVNode("input", {
                            type: "file",
                            accept: _ctx.bannerImgFileExtensions.join(','),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                            ref: "bannerImgFileInput",
                            style: {"display":"none"}
                          }, null, 40, _hoisted_20)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.bannerData.bannerImgFileName), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_22,
                      _hoisted_23,
                      _createElementVNode("td", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          id: "bannerCaption",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bannerData.bannerCaption) = $event)),
                          type: "text",
                          placeholder: "キャプション",
                          maxlength: "255",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.bannerData.bannerCaption]
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("td", _hoisted_27, [
                        _withDirectives(_createElementVNode("input", {
                          id: "dispDtFrom",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bannerData.dispDtFrom) = $event)),
                          type: "date",
                          class: "form-control",
                          max: _ctx.AppConstants.MAX_DATE_VALUE
                        }, null, 8, _hoisted_28), [
                          [_vModelText, _ctx.bannerData.dispDtFrom]
                        ])
                      ]),
                      _hoisted_29,
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          id: "dispDtTo",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bannerData.dispDtTo) = $event)),
                          type: "date",
                          class: "form-control",
                          max: _ctx.AppConstants.MAX_DATE_VALUE
                        }, null, 8, _hoisted_30), [
                          [_vModelText, _ctx.bannerData.dispDtTo]
                        ])
                      ]),
                      _hoisted_31
                    ])
                  ])
                ]),
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnClear",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                  }, " クリア "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnFixed",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
                  }, " 確定 ")
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}